import angular from 'angular';

import { AccountsController } from './accounts.controller';
import { AccountEditionController } from './account-edition.controller';
import { SiteGroupCreationController } from '../site-groups/site-group-creation.controller';
import { SiteGroupEditionController } from '../site-groups/site-group-edition.controller';
import { AccountsService } from './accounts.service';
import { SiteGroupsService } from '../site-groups/site-group.service';

angular
  .module('parameters.accounts', [])
  .controller('AccountsController', AccountsController)
  .controller('AccountEditionController', AccountEditionController)
  .controller('SiteGroupCreationController', SiteGroupCreationController)
  .controller('SiteGroupEditionController', SiteGroupEditionController)
  .factory('AccountsFactory', AccountsService.AccountsFactory)
  .factory('SitesGroupFactory', SiteGroupsService.SitesGroupFactory)